import React from 'react'
import Quiz from 'components/quiz/Quiz/Quiz'
import { Terms } from 'components/quiz/Terms/Terms'
import { SentryErrorBoundary } from 'components/common/SentryErrorBoundary'
import { Translate } from 'utils/translate'
import { connect } from 'react-redux'
import { getLanguage } from 'ducks/respondent'
import AbilityWelcome from './components/GMA/AbilityWelcome/AbilityWelcome'
import AbilityExample from './components/GMA/AbilityExample/AbilityExample'
import AbilityQuestionPage from './components/GMA/AbilityQuestionPage/AbilityQuestionPage'
import PersonalityQuestionPage from './components/personality/PersonalityQuestionPage/PersonalityQuestionPage'

import { addResizeListener } from 'utils/screen'
import {
  getLocation,
  PERSONALITY_QUIZ,
  QUIZ_MAIN,
  QUIZ_TERMS,
  GMA_QUIZ,
  GMA_QUIZ_GUIDE,
  GMA_QUIZ_WELCOME,
} from 'ducks/router'

const CandidateApp = ({ type, language }) => {
  React.useEffect(addResizeListener)
  const Page = {
    [QUIZ_MAIN]: Quiz,
    [QUIZ_TERMS]: Terms,
    [GMA_QUIZ_WELCOME]: AbilityWelcome,
    [GMA_QUIZ_GUIDE]: AbilityExample,
    [GMA_QUIZ]: AbilityQuestionPage,
    [PERSONALITY_QUIZ]: PersonalityQuestionPage,
  }[type]
  return (
    <SentryErrorBoundary>
      <div className="MobileAppPage">
        <Translate language={language}>
          <Page />
        </Translate>
      </div>
    </SentryErrorBoundary>
  )
}

export default connect(state => ({
  type: getLocation(state).type,
  language: getLanguage(state),
}))(CandidateApp)
